export default {
  CASE_EVENTS: {
    SHOW_ALL_EVENTS: 'Összes esemény mutatása',
    SHOW_LESS_EVENTS: 'Kevesebb esemény mutatása',
    PAYMENTS_OF_EVENT: 'Az eseményhez kapcsolódó befizetések:',
    NOTIFICATION_SENT: '{{channel}} elküldve:',
    NOTIFICATION_CHANNEL: {
      Email: 'E-mail',
      SMS: 'SMS',
      FinanceEmail: 'Pénzügyi e-mail',
    },
    ATTACHMENT: 'Csatolmány:',
    ATTACHMENTS: 'Csatolmányok:',
    MESSAGE_OF_EVENT: 'Az eseményhez kapcsolódó üzenet:',
    EXTERNAL_ID_OF_EVENT: 'Külső azonosító:',
    BAILIFF_CONTACT: 'Végrehajtó elérhetősége',
    EXTERNAL_ID_TYPE: {
      ENFORCEMENT: 'Végrehajtás ügyszám',
      BAILIFF: 'Végrehajtói jelványszám',
      OFP: 'Fizetési meghagyás ügyszám',
    },
    OK: 'Ok',
    ATTACH_MOKK_TO_LOG: 'MOKK hozzárendelése az eseményhez',
    REMOVE_MOKK_FROM_LOG: 'MOKK leválasztása az eseményről',
    ERROR_MESSAGES: {
      UNKNOWN_ERROR_WHILE_LOADING_EVENTS: 'Valami hiba történt az események betöltésekor!',
      ATTACH_MOKK_TO_LOG_FAILED: 'Nem sikerült a MOKK hozzárendelése az eseményhez.',
      DETACH_MOKK_FROM_LOG_FAILED: 'Nem sikerült a MOKK leválasztása az eseményről.',
    }
  },
};